<template>
	<div class="reports-dashboard">
		<!-- Five K Report PDF Component -->
			<FiveKReport v-if="checkCompany.is_bb || checkCompany.is_bt || checkCompany.is_gf || checkCompany.is_sb_india" ref="fiveKReport" :meta-data="computedFiveKReportMetaData"  :data="computedFiveKReportData" :previous-data="computedFiveKReportPreviousData"/>
		<!-- Five K Report PDF Component -->
		<el-row>
			<el-col :span="1">
				<img
					@click="go_back_to_dashboard()"
					width="35px"
					src="../../../../assets/icons/Back Arrow.png"
					style="cursor: pointer; position: relative; z-index: 1"
				/>
			</el-col>
			<el-col
				style="
					margin-top: 0px;
					color: #999999;
					margin-left: -10px;
					font-size: 16px;
				"
				:span="10"
			>
				<div
					@click="go_back_to_dashboard()"
					style="cursor: pointer; position: relative; z-index: 1"
				>
					Back
				</div>
			</el-col>
		</el-row>
		<el-row style="margin-top: 10px">
			<el-col :span="24">
				<span style="font-weight: bold; text-transform: capitalize">
					{{ storeObj.name }} Reports -
					{{
						project_tasksItems.filter((el) => el.id.includes(project_tasks))[0]
							.name
					}}
					<div>
						( {{ moment(from_date).format("Do MMM YYYY") }} -
						{{ moment(to_date).format("Do MMM YYYY") }} )
					</div></span
				>
			</el-col>
		</el-row>
		<el-row style="font-size: 16px; margin-top: 20px" :gutter="10">
			<el-col :span="24">
				<div style="background: white; padding: 5px">
					<el-row style="font-size: 16px; margin-top: 20px" :gutter="10">
						<el-col :span="20">
							<UserPerformanceGraphVue
								:labels="labels"
								:country_average="country_average"
								:region_average="region_average"
								:chart_data="chart_data"
								:chart_data1="chart_data1"
								:reportsTable="reportsTable"
							/>
						</el-col>
						<el-col :span="4" style="font-size: 12px">
							<el-row style="margin-top: -120px">
								<el-col :span="3">
									<div
										style="height: 15px; width: 15px; background-color: #d26300"
									></div>
								</el-col>
								<el-col :span="21">
									<div>
										{{
											project_tasksItems.filter((el) =>
												el.id.includes(project_tasks)
											)[0].name
										}}
									</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 15px; width: 15px; background-color: #eec383"
									></div>
								</el-col>
								<el-col :span="21">
									<div style="font-size: 13px">Completion %</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 5px; width: 15px; background-color: #ff4d01"
									></div>
								</el-col>
								<el-col :span="21">
									<div>Country Average</div>
								</el-col>
							</el-row>
							<el-row style="margin-top: 10px">
								<el-col :span="3">
									<div
										style="height: 5px; width: 15px; background-color: #b2beb5"
									></div>
								</el-col>
								<el-col :span="21">
									<div>Region Average</div>
								</el-col>
							</el-row>
						</el-col>
					</el-row>
				</div>
			</el-col>
		</el-row>
		<div style="margin-top: 20px; background: white; padding: 5px">
			<el-row
				v-loading="isloading"
				class="reports-table2"
				style="margin-top: 14px"
			>
				<el-col :span="24">
					<el-table
						style="text-transform: capitalize; word-break: break-word"
						height="500"
						:data="
							reportsTable

								.filter(
									(el) =>
										!selected_Date.length ||
										selected_Date.includes(el.project_end_date)
								)
								.filter(
									(el) =>
										!selected_Employee.length ||
										selected_Employee.includes(el.name)
								)
								.filter(
									(el) =>
										!selected_Designation.length ||
										selected_Designation.includes(el.designation)
								)
								.filter(
									(el, index) => index >= startNumber - 1 && index < endNumber
								)
						"
					>
						<el-table-column  width="150px" label="">
							<template slot="header" slot-scope="scope">
								Start Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Date">
											<el-checkbox
												v-for="(formItem, index) in uniqueDates.filter(
													(el) =>
														!searched_Date ||
														el
															.toLowerCase()
															.includes(searched_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Date = [...uniqueDates]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div>
									{{
										scope.row.project_start_date != 0
											? moment(scope.row.project_start_date).format(
													"Do MMM YYYY"
											  )
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column  width="150px" label="">
							<template slot="header" slot-scope="scope">
								End Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_end_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_end_Date">
											<el-checkbox
												v-for="(formItem, index) in uniqueDatesEnd.filter(
													(el) =>
														!searched_end_Date ||
														el
															.toLowerCase()
															.includes(searched_end_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_end_Date = [...uniqueDatesEnd]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_end_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_end_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div>
									{{
										scope.row.project_end_date != 0
											? moment(scope.row.project_end_date).format("Do MMM YYYY")
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column  width="150px" label="">
							<template slot="header" slot-scope="scope">
								Completion Date
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_completion_Date"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_completion_Date">
											<el-checkbox
												v-for="(
													formItem, index
												) in uniqueDatesCompletion.filter(
													(el) =>
														!searched_completion_Date ||
														el
															.toLowerCase()
															.includes(searched_completion_Date.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="
												selected_completion_Date = [...uniqueDatesCompletion]
											"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_completion_Date = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_completion_Date.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								{{scope.row.project_completion_date}}
								<div>
									{{
										scope.row.project_completion_date != 0
											? moment.utc(scope.row.project_completion_date).local().format(
													"Do MMM YYYY"
											  )
											: "-"
									}}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Employee">
							<template slot="header" slot-scope="scope">
								Employee
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Employee"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Employee">
											<el-checkbox
												v-for="(formItem, index) in uniqueEmployees.filter(
													(el) =>
														!searched_Employee ||
														el
															.toLowerCase()
															.includes(searched_Employee.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Employee = [...uniqueEmployees]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Employee = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Employee.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.name == 0 ? "-" : scope.row.name }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Designation">
							<template slot="header" slot-scope="scope">
								Designation
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Designation"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Designation">
											<el-checkbox
												v-for="(formItem, index) in uniqueDesignations.filter(
													(el) =>
														!searched_Designation ||
														el
															.toLowerCase()
															.includes(searched_Designation.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Designation = [...uniqueDesignations]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Designation = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Designation.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.designation == 0 ? "-" : scope.row.designation }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="150px" label="Region">
							<template slot="header" slot-scope="scope">
								Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_Region"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_Region">
											<el-checkbox
												v-for="(formItem, index) in uniqueRegions.filter(
													(el) =>
														!searched_Region ||
														el
															.toLowerCase()
															.includes(searched_Region.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_Region = [...uniqueRegions]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_Region = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_Region.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.region }}
								</div>
							</template>
						</el-table-column>
						<el-table-column width="180px" label="Sub Region">
							<template slot="header" slot-scope="scope">
								Sub Region
								<el-popover placement="right" trigger="click">
									<el-input
										v-model="searched_SubRegion"
										size="mini"
										placeholder="Search Date"
									></el-input>
									<div
										style="max-height: 250px; overflow: auto; margin-top: 10px"
									>
										<el-checkbox-group v-model="selected_SubRegion">
											<el-checkbox
												v-for="(formItem, index) in uniqueSubRegions.filter(
													(el) =>
														!searched_SubRegion ||
														el
															.toLowerCase()
															.includes(searched_SubRegion.toLowerCase())
												)"
												:key="index"
												class="mb-2 checkbox-lable"
												:label="formItem"
												style="display: block"
											></el-checkbox>
										</el-checkbox-group>
									</div>
									<div class="flex justify-between mt-4">
										<span
											class="text-xs cursor-pointer primary-theme-color"
											@click="selected_SubRegion = [...uniqueSubRegions]"
											>Select all</span
										>
										<span
											class="text-xs cursor-pointer"
											@click="selected_SubRegion = []"
											>Reset</span
										>
									</div>
									<span slot="reference">
										<img
											v-if="selected_SubRegion.length"
											src="../../../../assets/images/filter.png"
											width="9"
											class="cursor-pointer"
										/>
										<img
											v-else
											src="../../../../assets/images/filterBlack.png"
											width="9"
											class="cursor-pointer"
										/>
									</span>
								</el-popover>
							</template>
							<template slot-scope="scope">
								<div style="word-break: break-word">
									{{ scope.row.subregion }}
								</div>
							</template>
						</el-table-column>
						<el-table-column
							v-if="is_bb"
							sortable
								prop="critical_score_%"
								label="Critical Score"
								width="190px"
								style="word-break: break-word"
							>
							<template  slot-scope="scope">
								<span>{{scope.row['critical_score_%']}}%</span>

							</template>
							</el-table-column>
							<el-table-column
							v-if="is_bb"
							sortable
								prop="non_critical_score_%"
								label="Non Critical Score"
								width="190px"
								style="word-break: break-word"
							>
							<template  slot-scope="scope">
								<span>{{scope.row['non_critical_score_%']}}%</span>

							</template>
							</el-table-column>
						<el-table-column
							width="150px"
							sortable
							prop="total_score"
							label="Total Points"
						>
						</el-table-column>
						<el-table-column
							width="180px"
							sortable
							prop="current_score"
							label="Points Achieved"
						>
						</el-table-column>
						<el-table-column width="150px" sortable prop="" label="Score %">
							<template slot-scope="scope">
								{{ scope.row["score_completion_%"] }}%
							</template>
						</el-table-column>
						<el-table-column
							v-if="is_bb"
								sortable
								prop="weightage"
								label="Audit Score"
								width="190px"
								style="word-break: break-word"
							>
							<template  slot-scope="scope">
								<span>{{scope.row['weightage']}}%</span>

							</template>
							</el-table-column>
						<el-table-column
							width="160px"
							sortable
							prop="forms_completion_%"
							label="Completion %"
						>
							<template slot-scope="scope">
								{{ scope.row["forms_completion_%"] }}%
							</template>
						</el-table-column>
						<el-table-column fixed="right" width="180px">
							<template slot-scope="scope">
								<!-- <span
									style="
										cursor: pointer;
										color: #d26300;
										text-decoration: underline;
									"
									class="mx-3"
									>View</span 
								> -->
								<span
									:style="
										scope.row['completion_%'] != 0
											? `cursor: pointer;
										color: #d26300;
										text-decoration: underline;`
											: ''
									"
									@click="
										scope.row['completion_%'] != 0
											? downloadCsvReport(scope.row)
											: ''
									"
									>{{
										scope.row["completion_%"] != 0 ? "Download Report" : "-"
									}}</span
								>
							</template>
						</el-table-column>
					</el-table>
				</el-col>
			</el-row>
			<el-row :gutter="10" class="mt-3">
				<el-col :span="8" class="text-left">
					<div>
						<b>Showing</b> {{ startNumber }} to {{ endNumber }} of
						{{ reportsTable.length }} results
					</div>
				</el-col>
				<el-col :span="8" class="text-center">
					<el-select
						v-model="perPage"
						name="per_page"
						placeholder="select per page"
						style="width: 90px !important"
						size="mini"
					>
						<el-option label="10" :value="10"></el-option>
						<el-option label="25" :value="25"></el-option>
						<el-option label="50" :value="50"></el-option>
						<el-option label="100" :value="100"></el-option>
					</el-select>
					&nbsp;<b>per page</b>
				</el-col>
				<el-col :span="8" class="text-right">
					<el-pagination
						background
						layout="prev, pager, next"
						:total="reportsTable.length"
						:page-size="perPage"
						:current-page.sync="currentPage"
					></el-pagination>
				</el-col>
			</el-row>
		</div>
	</div>
</template>

<script>
import UserPerformanceGraphVue from "./UserPerformanceGraph.vue";
import formBuilderServices from "../../../../services/formBuilderServices";
import { mapState, mapActions } from "vuex";
import FiveKReport from "../../../UI/pdf/FiveKReport.vue";
import {EventBus} from '../../../../eventBus';

var moment = require("moment");

export default {
	components: {
		UserPerformanceGraphVue,
		FiveKReport
	},
	props: {
		storeObj: Object,
		current_view: String,
		project_tasks: String,
		project_tasksItems: Array,
		from_date: String,
		to_date: String,
		is_bb:Boolean
	},
	data: () => ({
		moment: moment,
		EventBus: EventBus,
		reportsTable: [],
		currentPage: 1,
		perPage: 10,
		selected_Date: [],
		selected_end_Date: [],
		selected_completion_Date: [],

		selected_Employee: [],
		selected_Designation: [],
		selected_Region: [],
		selected_SubRegion: [],
		searched_Date: "",
		searched_end_Date: "",
		searched_completion_Date: "",

		searched_Employee: "",
		searched_Designation: "",
		searched_Region: "",
		searched_SubRegion: "",
		isloading: false,
		region_average: [],
		labels: [],
		country_average: [],
		chart_data: [],
		chart_data1: [],
		five_k_report_data: {},
		is_5k_data_loaded: false,
	}),
	computed: {
		startNumber() {
			let start = this.currentPage * this.perPage - (this.perPage - 1);
			return start;
		},
		checkCompany() {
            return JSON.parse(localStorage.getItem('check_company'));
        },
		endNumber() {
			let end = Math.min(
				this.startNumber + this.perPage - 1,
				this.reportsTable.length
			);
			return end;
		},
		uniqueDates() {
			let arr = [
				...new Set(this.reportsTable.map((el) => el.project_start_date)),
			];
			return arr;
		},
		uniqueDatesCompletion() {
			let arr = [
				...new Set(this.reportsTable.map((el) => el.project_completion_date)),
			];
			return arr;
		},
		uniqueDatesEnd() {
			let arr = [
				...new Set(this.reportsTable.map((el) => el.project_end_date)),
			];
			return arr;
		},
		uniqueEmployees() {
			let arr = [...new Set(this.reportsTable.map((el) => el.name))];
			return arr;
		},
		uniqueDesignations() {
			let arr = [...new Set(this.reportsTable.map((el) => el.designation))];
			return arr;
		},
		uniqueRegions() {
			let arr = [...new Set(this.reportsTable.map((el) => el.region))];
			return arr;
		},
		uniqueSubRegions() {
			let arr = [...new Set(this.reportsTable.map((el) => el.subregion))];
			return arr;
		},
		computedFiveKReportData(){
			let original_data = {...this.five_k_report_data.project_execution};
			// if(this.checkCompany.is_bb && original_data.form_category_exeuctions){
            //     original_data.form_category_exeuctions.forEach((elm)=>{
            //         elm.form_executions.map((elm2) => {
            //             elm2.form_question_executions_data = (elm2.form_question_executions_data || []).filter((elm3) =>
            //                 elm3.task_status_update_info && elm3.task_status_update_info.current_score < 5
            //             );
            //         });
            //     });
            // }
			return original_data;
		},
		computedFiveKReportMetaData(){
			let original_data = {...this.five_k_report_data.meta};
			return original_data;
		},
		computedFiveKReportPreviousData(){
			let original_data = {...this.five_k_report_data.previous_projects};
			return original_data;
		}
	},
	watch:{
		
	},
	mounted() {
		if (this.current_view == "Page_2") {
			this.labels = [];
			let labels = [];
			let chart_data = [];
			this.chart_data = [];
			let chart_data1 = [];
			this.chart_data1 = [];

			this.labels = labels;
			this.country_average = [];
			let country_average = [];
			for (let i = 0; i < labels.length; i++) {
				country_average.push(
					this.storeObj.response.country_average["score_completion_%"]
				);
			}
			this.country_average = country_average;
			this.region_average = [];
			let region_average = [];
			if (this.storeObj.response.region_average["score_completion_%"]) {
				for (let i = 0; i < labels.length; i++) {
					region_average.push(
						this.storeObj.response.region_average["score_completion_%"]
					);
				}
				this.region_average = region_average;
			}

			this.reportsTable = this.storeObj.response.data;
			this.reportsTable = [...this.reportsTable].sort(
				(a, b) =>
					this.moment(a.project_start_date).format("x") -
					this.moment(b.project_start_date).format("x")
			);
			for (let i = 0; i < this.reportsTable.length; i++) {
				labels.push(
					this.moment(this.reportsTable[i].project_start_date).format(
						"Do MMM YYYY"
					)
				);
				if (this.reportsTable[i].total_score != 0) {
					chart_data.push(this.reportsTable[i]["score_completion_%"]);
				}
				chart_data1.push(this.reportsTable[i]["forms_completion_%"]);
			}

			this.chart_data = chart_data;
			this.chart_data1 = chart_data1;
			this.$forceUpdate();
			console.log(this.reportsTable,'reportsTable')
		}
	},
	methods: {
		...mapActions("CommonStore", [
			"addDownloadingReportCountAction",
			"removeDownloadingReportCountAction",
		]),
		// Function to get all five K report data
		downloadFiveKReport(id){
			let payload = { id: id };
			this.addDownloadingReportCountAction();
			formBuilderServices.getFiveKReportPdfData(payload).then((res)=>{
				this.five_k_report_data = JSON.parse(res.data);
				this.is_5k_data_loaded = true;
				this.removeDownloadingReportCountAction();
				if(this.is_5k_data_loaded && this.five_k_report_data.project_execution) {
					this.$nextTick(() => {
						// this.processPdfDownload();
						EventBus.$emit('loadPdfFirst');
						// this.$confirm('Your report has been successfully generated. Would you like to download it now?', 'Success', {
						// 	confirmButtonText: 'Download',
						// 	cancelButtonText: 'Cancel',
						// 	type: 'success',
						// 	customClass: 'ns-confirm-box',
						// }).then(() => {
						// 	setTimeout(() => {
						// 		EventBus.$emit('download5KPdf');
						// 	}, 500);
						// }).catch(() => {
						// 	this.$message({
						// 		type: 'info',
						// 		message: 'Download canceled. Feel free to download it later.'
						// 	});
						// });
					});
				}
			}).catch((err)=>{
				console.error(err);
				this.$notify.error({
					title: "Error",
					message: "Something went wrong!",
				});
				this.is_5k_data_loaded = false;
				this.removeDownloadingReportCountAction(); 
			}).finally(()=>{
				
			});
		},

		downloadReadyPdfDirect(){
			EventBus.$emit('download5KPdf');
		},
		
		downloadCsvReport(item) {

			if(this.checkCompany.is_bb || this.checkCompany.is_sb_india) { //  || this.checkCompany.is_bt || this.checkCompany.is_gf
				// PDF Report Download Function
				// this.downloadFiveKReport(item.project_execution_id);
				if(this.is_5k_data_loaded) {
					this.downloadReadyPdfDirect();
				} else {
				}
			} else {
				//Old function ************************** == DISABLED == *********************** Old function //
				this.addDownloadingReportCountAction("Report");
				this.is_csv_loading = true; //displayed loader on button
				// this.addDownloadingReportCountAction();
				var params = {
					project_execution: item.project_execution_id,
				};
				formBuilderServices
					.getDashboarLocationReport(params)
					.then((response) => {
						// if (response.status == 200) {
						// var fileURL = window.URL.createObjectURL(new Blob([response.data]));
						let fileURL =
							"data:application/pdf;charset=UTF-8," +
							encodeURIComponent(response.data);
						var fileLink = document.createElement("a");
						fileLink.href = fileURL;
						fileLink.setAttribute(
							"download",
							`${this.storeObj.name} - ${`${this.project_tasksItems.length != 0
								? this.project_tasksItems.filter((el) =>
									el.id.includes(this.project_tasks)
								)[0].name
								: "-"
							} - ` +
							this.from_date +
							"/" +
							this.to_date +
							".pdf"
							}`
						);
						document.body.appendChild(fileLink);
						fileLink.click();
						// }
						// this.removeDownloadingReportCountAction();
						this.removeDownloadingReportCountAction();
						this.is_csv_loading = false; //hide loader on button
					})
					.catch((err) => {
						console.log(err);
						this.is_csv_loading = false; //hide loader on button
						// this.abortDownloadingReportCountAction();
					this.removeDownloadingReportCountAction();

						this.$notify.error({
							title: "Error",
							message: "Something went wrong!",
						});
					});	
			}
		},
		go_back_to_dashboard() {
			this.$emit("clicked");
		},
	},
};
</script>

<style lang="scss">
.reports-dashboard {
	background-color: #f6f7f9;
	width: 100%;
	margin: auto;
	.reports-table2 {
			background-color: #ffffff;
		color: #333333;
		font-family: inherit !important;
		text-transform: none !important;
		text-align: left !important;
		.el-table th.el-table__cell > .cell {
			text-align: left !important;
			color: #333333 !important;
			text-transform: none !important;
		}
		tbody tr td {
			text-align: left !important;
		}
		.el-table tr {
			background-color: #fff;
			border-bottom: 1px solid #ebeef5;
			font-size: 13px;
			text-align: left !important;
		}
		.el-table__body-wrapper {
			overflow-y: auto;
			min-height: 62vh;
			max-height: 62vh;
		}
	}
}
</style>

<style>
.ns-confirm-box .el-message-box__title{
	color: #000;
	font-weight: 600;
}
</style>
